<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex align-center">
      <div class="w-50-porcento pr-2">
        <SysGrupoAutocomplete
          v-model="filtros.grupo"
          label="Grupos"
          outlined
          hide-details
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysFilialGrupoAutocomplete
          v-model="filtros.filial"
          label="Filial"
          outlined
          hide-details
          :ids-grupo="[filtros.grupo]"
          :unshift-items="{id: -1, descricao: 'Todas'}"
        />
      </div>
    </div>

    <SysSegmentoAutocomplete
      v-model="filtros.segmentos"
      label="Segmentos"
      outlined
      multiple
      hide-details
      :qtde-visivel-selecionados="1"
      class="mt-4"
    />

    <SysFornecedorAutocomplete
      v-model="filtros.fornecedores"
      label="Fornecedores"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      :qtde-visivel-selecionados="1"
      hide-details
      class="mt-4"
    />
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import $axios from "@/api/api";

export default {
  name: "CoberturaEstoque",
  mixins: [Mixin],
  components: {
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete
  },
  data: () => ({
    filtros: {
      grupo: 0,
      filial: -1,
      segmentos: [],
      fornecedores: [],
    }
  }),
  mounted() {
    this.filtros.grupo = this.$store.getters['usuario/getGrupoCompras'];
  },
  methods: {
    gerarRelatorio() {
      const form = document.createElement('form');

      form.setAttribute('action', $axios.defaults.baseURL + `/${this.relatorio.url}`);
      form.setAttribute('method', 'POST');
      form.setAttribute('target', '_blank');
      form.setAttribute('style', 'display: none;');

      if (!this.filtros.grupo) {
        this.filtros.grupo = this.$store.getters['usuario/getGrupoCompras'];
        this.filtros.filial = -1;
      }
      const filtros = { ...this.filtros };

      const array_filtros = ['segmentos', 'fornecedores'];
      array_filtros.forEach(item => this.Helpers.adicionarInputsFiltros(form, filtros, item));

      Object.keys(filtros).forEach(key => {
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', key);
        input.setAttribute('value', filtros[key]);
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();

      form.remove();

      this.DIALOG_ATIVO = false;
    }

  }
}
</script>

<style scoped>

</style>
